import { Grid } from "@shared/elements";

import { TCallCardFields, TSubmissionStatus } from "__generated__/types";

import CallCard from "src/components/CallCard";
import CallCardLink from "src/components/CallCardLink";

import { useCallCardLink } from "src/helpers";

type Props = {
  call: Parameters<ReturnType<typeof useCallCardLink>>[0] & TCallCardFields;
  /**
   * The page's `useCallCardLink`. Passed in rather than called here: the grids render up to
   * 112 of these, and the hook resolves the visit once per page.
   */
  resolveLink: ReturnType<typeof useCallCardLink>;
  /**
   * Where the visitor's own submission stands, which decides both where the card routes to and
   * what the card says. `"LOADING"` is a card-only state — it means we don't know yet, so the
   * link is built as if there were no submission.
   */
  submissionStatus?: TSubmissionStatus | "LOADING";
};

/**
 * One cell of a call grid: the card, wrapped in wherever that call routes to.
 *
 * Any other prop goes to `Grid.Item`, which is how `Grid` hands its children the index they
 * need for row borders.
 */
export default function CallGridItem({
  call,
  resolveLink,
  submissionStatus,
  ...gridItemProps
}: Props) {
  const status = submissionStatus === "LOADING" ? undefined : submissionStatus;

  return (
    <Grid.Item {...gridItemProps}>
      <CallCardLink link={resolveLink(call, status)}>
        <CallCard call={call} submissionStatus={submissionStatus} />
      </CallCardLink>
    </Grid.Item>
  );
}
